"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Marker = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const components_1 = require("@erm-tasku/components");
const react_i18next_1 = require("react-i18next");
const TriangleWrapper = styled_components_1.default.button `
	border: none;
	background: transparent;
	padding: 0;

	:focus {
		svg path {
			fill: white;
		}
	}
`;
function Marker({ onClick, marker, visited }) {
    const { t } = react_i18next_1.useTranslation();
    function handleClick(ev) {
        ev.preventDefault();
        onClick(marker);
    }
    const svgSize = marker.level === 1 ? 'large' : 'small';
    return (react_1.default.createElement(TriangleWrapper, { onClick: handleClick, onTouchStart: handleClick },
        react_1.default.createElement(components_1.Triangle, { label: t(`K${marker.highlightId}.pealkiri`), svgSize: svgSize, visited: visited })));
}
exports.Marker = Marker;
